import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import * as i1 from '@angular/cdk/layout';

/**
 * Modified copy of the Material breakpoint constant https://github.com/angular/components/blob/main/src/cdk/layout/breakpoints.ts
 */
// PascalCase is being used as Breakpoints is used like an enum.
// tslint:disable-next-line:variable-name
const CBreakpoints = {
  XSmall: '(max-width: 599.98px)',
  Small: '(min-width: 600px) and (max-width: 1023.98px)',
  Medium: '(min-width: 1024px) and (max-width: 1599.98px)',
  Large: '(min-width: 1600px) and (max-width: 1919.98px)',
  XLarge: '(min-width: 1920px)',
  Handset: '(max-width: 599.98px) and (orientation: portrait), ' + '(max-width: 959.98px) and (orientation: landscape)',
  Tablet: '(min-width: 600px) and (max-width: 839.98px) and (orientation: portrait), ' + '(min-width: 960px) and (max-width: 1279.98px) and (orientation: landscape)',
  Web: '(min-width: 840px) and (orientation: portrait), ' + '(min-width: 1280px) and (orientation: landscape)',
  HandsetPortrait: '(max-width: 599.98px) and (orientation: portrait)',
  TabletPortrait: '(min-width: 600px) and (max-width: 839.98px) and (orientation: portrait)',
  WebPortrait: '(min-width: 840px) and (orientation: portrait)',
  HandsetLandscape: '(max-width: 959.98px) and (orientation: landscape)',
  TabletLandscape: '(min-width: 960px) and (max-width: 1279.98px) and (orientation: landscape)',
  WebLandscape: '(min-width: 1280px) and (orientation: landscape)'
};
let WidthObserverService = /*#__PURE__*/(() => {
  class WidthObserverService {
    constructor(breakpointObserver) {
      this.breakpointObserver = breakpointObserver;
      this.isMobile$ = new BehaviorSubject(true);
      this.currentScreenSize$ = new BehaviorSubject('XSmall');
      // Create a map to display breakpoint names for demonstration purposes.
      this.displayNameMap = new Map([[CBreakpoints.XSmall, 'XSmall'], [CBreakpoints.Small, 'Small'], [CBreakpoints.Medium, 'Medium'], [CBreakpoints.Large, 'Large'], [CBreakpoints.XLarge, 'XLarge']]);
    }
    /**
     * Listens for changes in the screen size and returns the current screen size.
     * This should be called at a top level component in the app, once per lifecycle. This ensures that isMobile observable is correctly set.
     */
    listenBreakpoints() {
      return this.breakpointObserver.observe([CBreakpoints.XSmall, CBreakpoints.Small, CBreakpoints.Medium, CBreakpoints.Large, CBreakpoints.XLarge]).pipe(map(result => {
        let currentScreenSize = 'XSmall';
        Object.keys(result.breakpoints).some(query => {
          if (result.breakpoints[query]) {
            currentScreenSize = this.displayNameMap.get(query) ?? 'Unknown';
            this.currentScreenSize$.next(currentScreenSize);
          }
        });
        this.isMobile$.next(currentScreenSize === 'XSmall' || currentScreenSize === 'Small');
        return currentScreenSize;
      }));
    }
    /**
     * Returns the observable of the isMobile flag which is set to true if the breakpoint is XSmall or Small.
     * Will only change if the app is listening to breakpoints by subscribing to WidthObserverService.listenBreakpoints() at the top level
     */
    getIsMobile() {
      return this.isMobile$.asObservable();
    }
    getCurrentScreenSize() {
      return this.currentScreenSize$.asObservable();
    }
  }
  WidthObserverService.ɵfac = function WidthObserverService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || WidthObserverService)(i0.ɵɵinject(i1.BreakpointObserver));
  };
  WidthObserverService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: WidthObserverService,
    factory: WidthObserverService.ɵfac,
    providedIn: 'root'
  });
  return WidthObserverService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { CBreakpoints, WidthObserverService };
